import { render, staticRenderFns } from "./simple-card-info.vue?vue&type=template&id=a7f4f1fa&scoped=true&lang=pug&"
import script from "./simple-card-info.vue?vue&type=script&lang=js&"
export * from "./simple-card-info.vue?vue&type=script&lang=js&"
import style0 from "./simple-card-info.vue?vue&type=style&index=0&id=a7f4f1fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f4f1fa",
  null
  
)

export default component.exports